import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './intro.module.css';

class Intro extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    blurb: PropTypes.string.isRequired,
    goToPracticeBooking: PropTypes.func.isRequired,
  };
  state = {
    showAllText: false,
  };
  readMore = () => {
    this.setState({
      showAllText: true,
    });
  };
  render() {
    const { url, name, title, blurb, goToPracticeBooking } = this.props;
    return (
      <div className={styles.container}>
        <div className={styles.nameContainer}>
          <img src={url} className={styles.img} alt="doctor" />
          <span className={styles.name}>{name}</span>
          <span className={styles.drType}>{title}</span>
        </div>
        <button className={styles.button} onClick={goToPracticeBooking}>
          Book An Appointment
        </button>
        {blurb.length > 0 && <span className={styles.heading}>About Me</span>}
        {blurb.length > 0 && (
          <span
            className={classnames(styles.blurb, {
              [styles.fullBlurb]: this.state.showAllText,
            })}
          >
            {blurb}
          </span>
        )}
        {blurb.length > 150 && !this.state.showAllText && (
          <span className={styles.readMore}>
            <span>...</span>
            <span onClick={this.readMore} className={styles.readMoreText}>
              Read more
            </span>
          </span>
        )}
      </div>
    );
  }
}

export default Intro;
